import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styled from 'styled-components';

import SimpleButton, { COLOR, SIZE } from '@components/SimpleButton';

const Container = styled.div`
  color: ${({ theme }) => theme.colors.TextPrimary};
  font-family: ${({ theme }) => theme.fonts.secondaryFont};
  font-size: 15px;
  padding: ${({ theme }) => theme.commons.option.padding};
  margin-right: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;

  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.elementLine};
  }

  &.withIcon {
    justify-content: flex-start;
  }

  img {
    width: 15px;
    position: relative;
    right: 0px;
    padding-right: 4vw;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: ${props => (props.subtitle ? 'column' : 'row')};
  justify-content: space-between;
  width: 100%;
`;

const Subtitle = styled.span`
  font-family: ${({ theme }) => theme.fonts.secondaryFont};
  font-size: 12px;
  color: ${({ theme }) => theme.colors.textSecondary};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  align-self: self-start;
  margin-top: -2px;
  max-width: 80%;
`;

const OptionText = styled.span`
  align-self: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${({ theme }) => theme.colors.textPrimary};
  ${({ theme }) => theme.fontFamily.secondaryFont.mediumBold}
  margin-right:${({ theme }) => theme.spacing(2)};
`;
const OptionContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  max-width: 100%;
`;

function Option({ icon, label, actionText, subtitle, onClick, id }) {
  const classes = classnames({
    withSubtitle: !!subtitle,
    withIcon: !!icon,
  });

  return (
    <Container className={classes} onClick={() => onClick && onClick(id)}>
      {icon && <img src={icon} alt={`${label} action`} />}
      <Content subtitle={subtitle}>
        <OptionContainer>
          <OptionText>{label}</OptionText>
          {actionText && (
            <SimpleButton
              label={actionText}
              color={COLOR.SECONDARY}
              size={SIZE.SMALL}
            />
          )}
        </OptionContainer>
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
      </Content>
    </Container>
  );
}

Option.defaultProps = {
  icon: null,
  actionText: null,
  subtitle: null,
};

Option.propTypes = {
  // data
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.string,
  subtitle: PropTypes.string,
  actionText: PropTypes.string,

  // callbacks
  onClick: PropTypes.func,
};

export default Option;
